// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordionPanel__QlUrn {
  display: flex;
  align-items: center;
  column-gap: 5px;
  padding: 14.5px 15px;
  background-color: var(--tables-primary-row-surface-default);
  cursor: pointer;
}

.accordionPanelOpen__m1JoB {
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.accordionPanelNested__sRM8k {
  padding-left: 0;
}

.accordionPanelBordered__wpaCy {
  border: 1px solid var(--tables-primary-row-stroke);
}

.isNestedAccordion__S4Y_F {
  border-top: 1px solid var(--tables-primary-row-stroke);
}

.accordionArrow__yyL3i {
  width: 16px;
  height: 16px;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.accordionArrow__yyL3i path {
  stroke: var(--tables-primary-row-icon);
}

.accordionArrowOpen__SqZx2 {
  transform: rotate(180deg);
}

.accordionTitle__RX6Mr {
  font-size: 11px;
  font-weight: 600;
  line-height: 12px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
}

.accordionContent__OakEy {
  min-height: 0px;
  height: auto;
  padding: 0 25px 15px 35px;
  background-color: var(--tables-secondary-row-sub-title-surface);
  transition-duration: 278ms;
  transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.accordionContent__OakEy div[accordion=panel] {
  margin-left: 25px;
  padding-left: 0;
}

.accordionContentNested__DsjFZ {
  padding-left: 22px;
}

.accordionContentBordered__awCOG {
  border-left: 1px solid var(--tables-primary-row-stroke);
  border-right: 1px solid var(--tables-primary-row-stroke);
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Accordion/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,2DAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,+DAAA;AAzEF;;AA4EA;EACE,eAAA;AAzEF;;AA4EA;EACE,kDAAA;AAzEF;;AA4EA;EACE,sDAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,4DAAA;AAzEF;AA2EE;EACE,sCAAA;AAzEJ;;AA6EA;EACE,yBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,+DAAA;EACA,0BAAA;EACA,yDAAA;AA1EF;AA6EI;EACE,iBAAA;EACA,eAAA;AA3EN;;AAgFA;EACE,kBAAA;AA7EF;;AAgFA;EACE,uDAAA;EACA,wDAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.accordionPanel {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n  padding: 14.5px 15px;\n  background-color: var(--tables-primary-row-surface-default);\n  cursor: pointer;\n}\n\n.accordionPanelOpen {\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n\n.accordionPanelNested {\n  padding-left: 0;\n}\n\n.accordionPanelBordered {\n  border: 1px solid var(--tables-primary-row-stroke);\n}\n\n.isNestedAccordion {\n  border-top: 1px solid var(--tables-primary-row-stroke);\n}\n\n.accordionArrow {\n  width: 16px;\n  height: 16px;\n  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  path {\n    stroke: var(--tables-primary-row-icon);\n  }\n}\n\n.accordionArrowOpen {\n  transform: rotate(180deg);\n}\n\n.accordionTitle {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 12px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n}\n\n.accordionContent {\n  min-height: 0px;\n  height: auto;\n  padding: 0 25px 15px 35px;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n  transition-duration: 278ms;\n  transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  :global {\n    div[accordion='panel'] {\n      margin-left: 25px;\n      padding-left: 0;\n    }\n  }\n}\n\n.accordionContentNested {\n  padding-left: 22px;\n}\n\n.accordionContentBordered {\n  border-left: 1px solid var(--tables-primary-row-stroke);\n  border-right: 1px solid var(--tables-primary-row-stroke);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordionPanel": `accordionPanel__QlUrn`,
	"accordionPanelOpen": `accordionPanelOpen__m1JoB`,
	"accordionPanelNested": `accordionPanelNested__sRM8k`,
	"accordionPanelBordered": `accordionPanelBordered__wpaCy`,
	"isNestedAccordion": `isNestedAccordion__S4Y_F`,
	"accordionArrow": `accordionArrow__yyL3i`,
	"accordionArrowOpen": `accordionArrowOpen__SqZx2`,
	"accordionTitle": `accordionTitle__RX6Mr`,
	"accordionContent": `accordionContent__OakEy`,
	"accordionContentNested": `accordionContentNested__DsjFZ`,
	"accordionContentBordered": `accordionContentBordered__awCOG`
};
module.exports = ___CSS_LOADER_EXPORT___;
